import axios from "axios";
import { ERROR_HANDLE, API_URL } from 'config/constants';

export const METHODS = {
    POST: "POST",
    GET: "GET",
    PUT: "PUT",
    DELETE: "DELETE"
}

/**
 * Make the network request to the default HOST.
 * @param {*} path the request path.
 * @param {*} method the request method GET/PUT/POST/DELETE.
 * @param {*} body the request body if any. this is optional.
 */
export function makeRequest(path, method, body) {
    return new Promise((resolve, reject) => {
        axios({
            url: `${API_URL}${path}`,
            method: method,
            headers: {
                "x-access-token": localStorage.getItem("access_token")
            },
            data: body
        })
            .then(response => {
                if (!response.data.error)
                    resolve(response.data);
                else
                    reject(response.data);

            }).catch(err => {
                reject(err);
            });
    });
}